import React from 'react';
import { Link } from 'react-router-dom';
import caseOnePreview from '../images/work/case_one_preview.webp';
import caseTwoPreview from '../images/work/case-two-preview-stacked.webp';
import caseThreePreview from '../images/work/case-three-design-system-preview.webp';

const projects = [
	{
		title: 'Navigation redesign',
		description:
			'Rebuilding navigation around the workspace apps people actually rely on, and preparing the product for a multiworkspace future. Cutting movement between apps from four clicks to one.',
		tags: ['2026', 'B2B SaaS', 'Product design', 'Frontend', 'Backend'],
		image: caseOnePreview,
		imageAlt: 'Preview of the redesigned Hailer navigation',
		caseId: 'case-one',
	},
	{
		title: 'Stackable drawer interface',
		description:
			'Replacing a single-drawer UI with a stack-based system, so people can open, switch between, and keep track of multiple items without losing context.',
		tags: ['2026', 'B2B SaaS', 'UX', 'UI', 'Interaction design', 'Frontend'],
		image: caseTwoPreview,
		imageAlt: 'Preview of the stackable drawer interface',
		caseId: 'case-two',
	},
	{
		title: 'Scaling design system across platforms',
		description:
			'Modernizing and unifying the UI across Angular and React, so developers can build consistent, accessible interfaces from shared patterns instead of ad-hoc styling.',
		tags: ['2025', 'B2B SaaS', 'Design systems', 'Accessibility', 'Frontend'],
		image: caseThreePreview,
		imageAlt: 'Preview of the cross-platform design system',
		caseId: 'case-three',
	},
];

const Projects = () => {
	return (
		<div className="background" id="work">
			<div className="section-wrapper">
				<h2>Work</h2>
				<div className="projects-list">
					{projects.map((project) => (
						<article className="project-card" key={project.title}>
							{project.image ? (
								<img
									className="project-image"
									src={project.image}
									alt={project.imageAlt || ''}
									loading="lazy"
								/>
							) : (
								<div className="project-image" aria-hidden="true"></div>
							)}
							<div className="project-body">
								<h3 className="project-title">{project.title}</h3>
								{project.tags.length > 0 && (
									<ul className="project-tags">
										{project.tags.map((tag) => (
											<li key={tag}>{tag}</li>
										))}
									</ul>
								)}
								<p className="project-description">{project.description}</p>
								<Link className="project-link" to={`/cases#${project.caseId}`}>
									View case study
								</Link>
							</div>
						</article>
					))}
				</div>
			</div>
		</div>
	);
};

export default Projects;
